module.exports = __webpack_public_path__ + "static/media/store_new.5bdeadbd.svg";